/**
 * @voltxampere/ui — DC Voltage Source (DC Kaynak)
 *
 * Circle with `+` (top) and `−` (bottom) glyphs inside — the IEC
 * convention for an ideal DC source. Connection terminals sit at
 * (20, 3) and (20, 23); short lead lines extend from the pins to
 * the viewBox edges (y=0/y=26) so the wire-routing snap target
 * reads visually from the symbol's outer edge.
 *
 * Sprint 25 R3 lane 1 added the lead lines + redrew the polarity
 * glyphs as a clean `+`/`−` pair (the pre-Sprint-25 rendering had
 * three stacked horizontal bars from a `+/−/−/−` IEC variant that
 * read poorly at small zoom). The geometry mirrors v1
 * (`~/Desktop/VoltXAmpere/src/components/definitions.js:84` `vdc`)
 * — v1 leads at 80-px sprite scale port to 3-px stubs here.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { STROKE_IVORY, STROKE_WIDTH_MAIN, VIEWBOX_DEFAULT } from "./constants.js";
export const dcSource = {
    id: "dc-source",
    nameTr: "DC Kaynak",
    nameEn: "DC Source",
    shortcut: "V",
    category: "source",
    viewBox: VIEWBOX_DEFAULT,
    terminals: [
        { x: 20, y: 3, label: "+", polarity: "out" },
        { x: 20, y: 23, label: "−", polarity: "in" },
    ],
    defaultLabel: "V",
    defaultValue: "5V",
    renderSVG: () => [
        // Sprint 25 R3 lane 1 — pin lead lines (viewBox edge → pin).
        `<line x1="20" y1="0" x2="20" y2="3" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="20" y1="23" x2="20" y2="26" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // Body circle.
        `<circle cx="20" cy="13" r="10" fill="none" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // `+` glyph in the upper half (small cross at 16,10).
        `<line x1="14" y1="10" x2="18" y2="10" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        `<line x1="16" y1="8" x2="16" y2="12" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
        // `−` glyph in the lower half (single horizontal bar at 24,16).
        `<line x1="22" y1="16" x2="26" y2="16" stroke="${STROKE_IVORY}" stroke-width="${String(STROKE_WIDTH_MAIN)}"/>`,
    ].join(""),
};
//# sourceMappingURL=dc-source.js.map